import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {
  JaarrapportageEntity,
  ClientEntity,
  Jaarrekening, Jaarrapportage
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {combineLatest, Subject, takeUntil} from 'rxjs';
import {
  SpecFormattedexplanationpolicyComponent
} from '../spec-formattedexplanationpolicy/spec-formattedexplanationpolicy.component';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-grondslagen-balans',
  templateUrl: './grondslagen-balans.component.html',
  imports: [
    SpecFormattedexplanationpolicyComponent,
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    CommonModule
  ],
  styleUrls: ['./grondslagen-balans.component.scss']
})
export class GrondslagenBalansComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  public index = 0;
  public dialogVisible = false;
  public clientEntity = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public isCooperatie = false;
  public isEnkelvoudig = false;
  public isFiscaleGrondslagen = false;
  public isBalansNaResultaatbestemming = false;

  public impairmentAssetsNoncurrentPolicyFg = {} as FormGroup;
  public intangibleAssetsPolicyFg = {} as FormGroup;
  public developmentCostsPolicyFg = {} as FormGroup;
  public patentsTrademarksOtherRightsPolicyFg = {} as FormGroup;
  public goodwillPolicyFg = {} as FormGroup;
  public propertyPlantEquipmentPolicyFg = {} as FormGroup;
  public investmentPropertiesPolicyFg = {} as FormGroup;
  public realEstateInDevelopmentPolicyFg = {} as FormGroup;
  public financialAssetsPolicyFg = {} as FormGroup;
  public investmentsInParticipatingInterestsInGroupCompaniesPolicyFg = {} as FormGroup;
  public investmentsOtherAffiliatedCompaniesPolicyFg = {} as FormGroup;
  public receivablesGroupCompaniesPolicyFg = {} as FormGroup;
  public securitiesOtherNoncurrentPolicyFg = {} as FormGroup;
  public deferredTaxAssetsPolicyFg = {} as FormGroup;
  public inventoriesPolicyFg = {} as FormGroup;
  public workInProgressPolicyFg = {} as FormGroup;
  public constructionContractsPolicyFg = {} as FormGroup;
  public receivablesPolicyFg = {} as FormGroup;
  public securitiesCurrentPolicyFg = {} as FormGroup;
  public cashAndCashEquivalentsPolicyFg = {} as FormGroup;
  public equityPolicyFg = {} as FormGroup;
  public shareCapitalPaidCalledUpPolicyFg = {} as FormGroup;
  public sharePremiumPolicyFg = {} as FormGroup;
  public revaluationReservePolicyFg = {} as FormGroup;
  public legalReservesPolicyFg = {} as FormGroup;
  public statutoryReservesPolicyFg = {} as FormGroup;
  public reinvestmentReservePolicyFg = {} as FormGroup;
  public reservesOtherPolicyFg = {} as FormGroup;
  public otherFiscalReservesPolicyFg = {} as FormGroup;
  public retainedEarningsPolicyFg = {} as FormGroup;
  public resultForTheYearPolicyFg = {} as FormGroup;
  public provisionsPolicyFg = {} as FormGroup;
  public provisionMajorMaintenancePolicyFg = {} as FormGroup;
  public provisionRestructuringPolicyFg = {} as FormGroup;
  public provisionWarrantyPolicyFg = {} as FormGroup;
  public provisionsOtherPolicyFg = {} as FormGroup;
  public liabilitiesNoncurrentPolicyFg = {} as FormGroup;
  public liabilitiesCurrentPolicyFg = {} as FormGroup;
  public deferredTaxLiabilitiesPolicyFg = {} as FormGroup;
  public oldAgeObligationPolicyFg = {} as FormGroup;
  public negativeGoodwillPolicyFg = {} as FormGroup;

  //t.b.v. zichtbaarheid balans onderdelen
  public heeftImmaterieleVasteActiva = false;
  public heeftMaterieleVasteActiva = false;
  public heeftFinancieleVasteActiva = false;
  public heeftVastgoedBeleggingen = false;
  public heeftVoorraden = false;
  public heeftOnderhandenProjecten = false;
  public heeftVorderingen = false;
  public heeftEffecten = false;
  public heeftLiquideMiddelen = false;
  public heeftAandelenkapitaal = false;
  public heeftAgio = false;
  public heeftHerwaarderingsreserve = false;
  public heeftAndereWettelijkeReserves = false;
  public heeftStatutaireReserves = false;
  public heeftHerinvesteringsreserve = false;
  public heeftOverigeReserves = false;
  public heeftOverigeFiscaleReserves = false;
  public heeftResultaatBoekjaar = false;
  public heeftNietVerdeeldeWinsten = false;
  public heeftVoorzieningen = false;
  public heeftKortlopendeSchulden = false;
  public heeftLanglopendeSchulden = false;

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  private destroy$ = new Subject<void>();

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService) {
    this.impairmentAssetsNoncurrentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.intangibleAssetsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.developmentCostsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.patentsTrademarksOtherRightsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.goodwillPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.propertyPlantEquipmentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.investmentPropertiesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.realEstateInDevelopmentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.financialAssetsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.investmentsOtherAffiliatedCompaniesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.receivablesGroupCompaniesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.securitiesOtherNoncurrentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.deferredTaxAssetsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.inventoriesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.workInProgressPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.constructionContractsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.receivablesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.securitiesCurrentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.cashAndCashEquivalentsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.equityPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.shareCapitalPaidCalledUpPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.sharePremiumPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.revaluationReservePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.legalReservesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.statutoryReservesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.reinvestmentReservePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.reservesOtherPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.otherFiscalReservesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.retainedEarningsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.resultForTheYearPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.provisionsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.provisionMajorMaintenancePolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.provisionRestructuringPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.provisionWarrantyPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.provisionsOtherPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.liabilitiesNoncurrentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.liabilitiesCurrentPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.deferredTaxLiabilitiesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.oldAgeObligationPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.negativeGoodwillPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.clientEntity = value;
    });
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
    this.jrDataService.isCooperatie.subscribe((value) => {
      this.isCooperatie = value;
    })
    this.jrDataService.isEnkelvoudig.subscribe((value) => {
      this.isEnkelvoudig = value;
    })
    this.jrDataService.isFiscaleGrondslagen.subscribe((value) => {
      this.isFiscaleGrondslagen = value;
    })
    this.jrDataService.isBalansNaResultaatbestemming.subscribe((value) => {
      this.isBalansNaResultaatbestemming = value;
    })

    const sources = {
      heeftImmaterieleVasteActiva: this.jrDataService.heeftImmaterieleVasteActiva,
      heeftMaterieleVasteActiva: this.jrDataService.heeftMaterieleVasteActiva,
      heeftFinancieleVasteActiva: this.jrDataService.heeftFinancieleVasteActiva,
      heeftVastgoedBeleggingen: this.jrDataService.heeftVastgoedBeleggingen,
      heeftVoorraden: this.jrDataService.heeftVoorraden,
      heeftOnderhandenProjecten: this.jrDataService.heeftOnderhandenProjecten,
      heeftVorderingen: this.jrDataService.heeftVorderingen,
      heeftEffecten: this.jrDataService.heeftEffecten,
      heeftLiquideMiddelen: this.jrDataService.heeftLiquideMiddelen,
      heeftAandelenkapitaal: this.jrDataService.heeftAandelenkapitaal,
      heeftAgio: this.jrDataService.heeftAgio,
      heeftHerwaarderingsreserve: this.jrDataService.heeftHerwaarderingsreserve,
      heeftAndereWettelijkeReserves: this.jrDataService.heeftAndereWettelijkeReserves,
      heeftStatutaireReserves: this.jrDataService.heeftStatutaireReserves,
      heeftHerinvesteringsreserve: this.jrDataService.heeftHerinvesteringsreserve,
      heeftOverigeReserves: this.jrDataService.heeftOverigeReserves,
      heeftOverigeFiscaleReserves: this.jrDataService.heeftOverigeFiscaleReserves,
      heeftResultaatBoekjaar: this.jrDataService.heeftResultaatBoekjaar,
      heeftNietVerdeeldeWinsten: this.jrDataService.heeftNietVerdeeldeWinsten,
      heeftVoorzieningen: this.jrDataService.heeftVoorzieningen,
      heeftKortlopendeSchulden: this.jrDataService.heeftKortlopendeSchulden,
      heeftLanglopendeSchulden: this.jrDataService.heeftLanglopendeSchulden
    } as const;

    combineLatest(sources)
      .subscribe((values) => {
        Object.assign(this, values);
      });

    this.jrDataService.jaarrapportageEntity.pipe(takeUntil(this.destroy$)).subscribe((jrEntity) => {
      this.jrEntity = jrEntity;
      this.patchData(jrEntity);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private patchData(value: JaarrapportageEntity) {
    const text = value.rapportage?.jaarrekeningen?.at(0)?.toelichting?.grondslagen?.grondslagenBalans;
    if (text) {
      if (text.impairmentAssetsNoncurrentPolicy) {
        this.impairmentAssetsNoncurrentPolicyFg.patchValue(text.impairmentAssetsNoncurrentPolicy);
      }
      if (text.intangibleAssetsPolicy) {
        this.intangibleAssetsPolicyFg.patchValue(text.intangibleAssetsPolicy);
      }
      if (text.developmentCostsPolicy) {
        this.developmentCostsPolicyFg.patchValue(text.developmentCostsPolicy);
      }
      if (text.patentsTrademarksOtherRightsPolicy) {
        this.patentsTrademarksOtherRightsPolicyFg.patchValue(text.patentsTrademarksOtherRightsPolicy);
      }
      if (text.goodwillPolicy) {
        this.goodwillPolicyFg.patchValue(text.goodwillPolicy);
      }
      if (text.propertyPlantEquipmentPolicy) {
        this.propertyPlantEquipmentPolicyFg.patchValue(text.propertyPlantEquipmentPolicy);
      }
      if (text.investmentPropertiesPolicy) {
        this.investmentPropertiesPolicyFg.patchValue(text.investmentPropertiesPolicy);
      }
      if (text.realEstateInDevelopmentPolicy) {
        this.realEstateInDevelopmentPolicyFg.patchValue(text.realEstateInDevelopmentPolicy);
      }
      if (text.financialAssetsPolicy) {
        this.financialAssetsPolicyFg.patchValue(text.financialAssetsPolicy);
      }
      if (text.investmentsInParticipatingInterestsInGroupCompaniesPolicy) {
        this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg.patchValue(text.investmentsInParticipatingInterestsInGroupCompaniesPolicy);
      }
      if (text.investmentsOtherAffiliatedCompaniesPolicy) {
        this.investmentsOtherAffiliatedCompaniesPolicyFg.patchValue(text.investmentsOtherAffiliatedCompaniesPolicy);
      }
      if (text.receivablesGroupCompaniesPolicy) {
        this.receivablesGroupCompaniesPolicyFg.patchValue(text.receivablesGroupCompaniesPolicy);
      }
      if (text.securitiesOtherNoncurrentPolicy) {
        this.securitiesOtherNoncurrentPolicyFg.patchValue(text.securitiesOtherNoncurrentPolicy);
      }
      if (text.deferredTaxAssetsPolicy) {
        this.deferredTaxAssetsPolicyFg.patchValue(text.deferredTaxAssetsPolicy);
      }
      if (text.inventoriesPolicy) {
        this.inventoriesPolicyFg.patchValue(text.inventoriesPolicy);
      }
      if (text.workInProgressPolicy) {
        this.workInProgressPolicyFg.patchValue(text.workInProgressPolicy);
      }
      if (text.constructionContractsPolicy) {
        this.constructionContractsPolicyFg.patchValue(text.constructionContractsPolicy);
      }
      if (text.receivablesPolicy) {
        this.receivablesPolicyFg.patchValue(text.receivablesPolicy);
      }
      if (text.securitiesCurrentPolicy) {
        this.securitiesCurrentPolicyFg.patchValue(text.securitiesCurrentPolicy);
      }
      if (text.cashAndCashEquivalentsPolicy) {
        this.cashAndCashEquivalentsPolicyFg.patchValue(text.cashAndCashEquivalentsPolicy);
      }
      if (text.equityPolicy) {
        this.equityPolicyFg.patchValue(text.equityPolicy);
      }
      if (text.shareCapitalPaidCalledUpPolicy) {
        this.shareCapitalPaidCalledUpPolicyFg.patchValue(text.shareCapitalPaidCalledUpPolicy);
      }
      if (text.sharePremiumPolicy) {
        this.sharePremiumPolicyFg.patchValue(text.sharePremiumPolicy);
      }
      if (text.revaluationReservePolicy) {
        this.revaluationReservePolicyFg.patchValue(text.revaluationReservePolicy);
      }
      if (text.legalReservesPolicy) {
        this.legalReservesPolicyFg.patchValue(text.legalReservesPolicy);
      }
      if (text.statutoryReservesPolicy) {
        this.statutoryReservesPolicyFg.patchValue(text.statutoryReservesPolicy);
      }
      if (text.reinvestmentReservePolicy) {
        this.reinvestmentReservePolicyFg.patchValue(text.reinvestmentReservePolicy);
      }
      if (text.reservesOtherPolicy) {
        this.reservesOtherPolicyFg.patchValue(text.reservesOtherPolicy);
      }
      if (text.otherFiscalReservesPolicy) {
        this.otherFiscalReservesPolicyFg.patchValue(text.otherFiscalReservesPolicy);
      }
      if (text.retainedEarningsPolicy) {
        this.retainedEarningsPolicyFg.patchValue(text.retainedEarningsPolicy);
      }
      if (text.resultForTheYearPolicy) {
        this.resultForTheYearPolicyFg.patchValue(text.resultForTheYearPolicy);
      }
      if (text.provisionsPolicy) {
        this.provisionsPolicyFg.patchValue(text.provisionsPolicy);
      }
      if (text.provisionMajorMaintenancePolicy) {
        this.provisionMajorMaintenancePolicyFg.patchValue(text.provisionMajorMaintenancePolicy);
      }
      if (text.provisionRestructuringPolicy) {
        this.provisionRestructuringPolicyFg.patchValue(text.provisionRestructuringPolicy);
      }
      if (text.deferredTaxLiabilitiesPolicy) {
        this.deferredTaxLiabilitiesPolicyFg.patchValue(text.deferredTaxLiabilitiesPolicy);
      }
      if (text.provisionWarrantyPolicy) {
        this.provisionWarrantyPolicyFg.patchValue(text.provisionWarrantyPolicy);
      }
      if (text.provisionsOtherPolicy) {
        this.provisionsOtherPolicyFg.patchValue(text.provisionsOtherPolicy);
      }
      if (text.oldAgeObligationPolicy) {
        this.oldAgeObligationPolicyFg.patchValue(text.oldAgeObligationPolicy);
      }
      if (text.negativeGoodwillPolicy) {
        this.negativeGoodwillPolicyFg.patchValue(text.negativeGoodwillPolicy);
      }
      if (text.liabilitiesNoncurrentPolicy) {
        this.liabilitiesNoncurrentPolicyFg.patchValue(text.liabilitiesNoncurrentPolicy);
      }
      if (text.liabilitiesCurrentPolicy) {
        this.liabilitiesCurrentPolicyFg.patchValue(text.liabilitiesCurrentPolicy);
      }
    }
  }

  saveForm(): void {
    this.impairmentAssetsNoncurrentPolicyFg.updateValueAndValidity();
    this.intangibleAssetsPolicyFg.updateValueAndValidity();
    this.developmentCostsPolicyFg.updateValueAndValidity();
    this.patentsTrademarksOtherRightsPolicyFg.updateValueAndValidity();
    this.goodwillPolicyFg.updateValueAndValidity();
    this.propertyPlantEquipmentPolicyFg.updateValueAndValidity();
    this.investmentPropertiesPolicyFg.updateValueAndValidity();
    this.realEstateInDevelopmentPolicyFg.updateValueAndValidity();
    this.financialAssetsPolicyFg.updateValueAndValidity();
    this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg.updateValueAndValidity();
    this.investmentsOtherAffiliatedCompaniesPolicyFg.updateValueAndValidity();
    this.receivablesGroupCompaniesPolicyFg.updateValueAndValidity();
    this.securitiesOtherNoncurrentPolicyFg.updateValueAndValidity();
    this.deferredTaxAssetsPolicyFg.updateValueAndValidity();
    this.inventoriesPolicyFg.updateValueAndValidity();
    this.workInProgressPolicyFg.updateValueAndValidity();
    this.constructionContractsPolicyFg.updateValueAndValidity();
    this.receivablesPolicyFg.updateValueAndValidity();
    this.securitiesCurrentPolicyFg.updateValueAndValidity();
    this.cashAndCashEquivalentsPolicyFg.updateValueAndValidity();
    this.equityPolicyFg.updateValueAndValidity();
    this.shareCapitalPaidCalledUpPolicyFg.updateValueAndValidity();
    this.sharePremiumPolicyFg.updateValueAndValidity();
    this.revaluationReservePolicyFg.updateValueAndValidity();
    this.legalReservesPolicyFg.updateValueAndValidity();
    this.statutoryReservesPolicyFg.updateValueAndValidity();
    this.reinvestmentReservePolicyFg.updateValueAndValidity();
    this.reservesOtherPolicyFg.updateValueAndValidity();
    this.otherFiscalReservesPolicyFg.updateValueAndValidity();
    this.retainedEarningsPolicyFg.updateValueAndValidity();
    this.resultForTheYearPolicyFg.updateValueAndValidity();
    this.provisionsPolicyFg.updateValueAndValidity();
    this.provisionMajorMaintenancePolicyFg.updateValueAndValidity();
    this.provisionRestructuringPolicyFg.updateValueAndValidity();
    this.provisionWarrantyPolicyFg.updateValueAndValidity();
    this.provisionsOtherPolicyFg.updateValueAndValidity();
    this.liabilitiesNoncurrentPolicyFg.updateValueAndValidity();
    this.liabilitiesCurrentPolicyFg.updateValueAndValidity();
    this.deferredTaxLiabilitiesPolicyFg.updateValueAndValidity();
    this.oldAgeObligationPolicyFg.updateValueAndValidity();
    this.negativeGoodwillPolicyFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          grondslagen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.grondslagen,
            grondslagenBalans: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.grondslagen?.grondslagenBalans,
              impairmentAssetsNoncurrentPolicy: this.impairmentAssetsNoncurrentPolicyFg.value,
              intangibleAssetsPolicy: this.intangibleAssetsPolicyFg.value,
              developmentCostsPolicy: this.developmentCostsPolicyFg.value,
              patentsTrademarksOtherRightsPolicy: this.patentsTrademarksOtherRightsPolicyFg.value,
              goodwillPolicy: this.goodwillPolicyFg.value,
              propertyPlantEquipmentPolicy: this.propertyPlantEquipmentPolicyFg.value,
              investmentPropertiesPolicy: this.investmentPropertiesPolicyFg.value,
              realEstateInDevelopmentPolicy: this.realEstateInDevelopmentPolicyFg.value,
              financialAssetsPolicy: this.financialAssetsPolicyFg.value,
              investmentsInParticipatingInterestsInGroupCompaniesPolicy: this.investmentsInParticipatingInterestsInGroupCompaniesPolicyFg.value,
              investmentsOtherAffiliatedCompaniesPolicy: this.investmentsOtherAffiliatedCompaniesPolicyFg.value,
              receivablesGroupCompaniesPolicy: this.receivablesGroupCompaniesPolicyFg.value,
              securitiesOtherNoncurrentPolicy: this.securitiesOtherNoncurrentPolicyFg.value,
              deferredTaxAssetsPolicy: this.deferredTaxAssetsPolicyFg.value,
              inventoriesPolicy: this.inventoriesPolicyFg.value,
              workInProgressPolicy: this.workInProgressPolicyFg.value,
              constructionContractsPolicy: this.constructionContractsPolicyFg.value,
              receivablesPolicy: this.receivablesPolicyFg.value,
              securitiesCurrentPolicy: this.securitiesCurrentPolicyFg.value,
              cashAndCashEquivalentsPolicy: this.cashAndCashEquivalentsPolicyFg.value,
              equityPolicy: this.equityPolicyFg.value,
              shareCapitalPaidCalledUpPolicy: this.shareCapitalPaidCalledUpPolicyFg.value,
              sharePremiumPolicy: this.sharePremiumPolicyFg.value,
              revaluationReservePolicy: this.revaluationReservePolicyFg.value,
              legalReservesPolicy: this.legalReservesPolicyFg.value,
              statutoryReservesPolicy: this.statutoryReservesPolicyFg.value,
              reinvestmentReservePolicy: this.reinvestmentReservePolicyFg.value,
              reservesOtherPolicy: this.reservesOtherPolicyFg.value,
              otherFiscalReservesPolicy: this.otherFiscalReservesPolicyFg.value,
              retainedEarningsPolicy: this.retainedEarningsPolicyFg.value,
              resultForTheYearPolicy: this.resultForTheYearPolicyFg.value,
              provisionsPolicy: this.provisionsPolicyFg.value,
              provisionMajorMaintenancePolicy: this.provisionMajorMaintenancePolicyFg.value,
              provisionRestructuringPolicy: this.provisionRestructuringPolicyFg.value,
              deferredTaxLiabilitiesPolicy: this.deferredTaxLiabilitiesPolicyFg.value,
              provisionWarrantyPolicy: this.provisionWarrantyPolicyFg.value,
              provisionsOtherPolicy: this.provisionsOtherPolicyFg.value,
              oldAgeObligationPolicy: this.oldAgeObligationPolicyFg.value,
              negativeGoodwillPolicy: this.negativeGoodwillPolicyFg.value,
              liabilitiesNoncurrentPolicy: this.liabilitiesNoncurrentPolicyFg.value,
              liabilitiesCurrentPolicy: this.liabilitiesCurrentPolicyFg.value,
            },
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}
